module.exports = __webpack_public_path__ + "static/arcadium-anneler-gunu-2ae63a2f59b881f839326f0a5b860643.mp4";